import { Space } from 'antd'
import React, { useState } from 'react'
import PageHeading from '../../../../components/common/PageHeading'
import { Input } from 'antd';
import SundayCard from './WeeksDays/SundayCard';
import MondayCard from './WeeksDays/MondayCard';
import TuesdayCard from './WeeksDays/TuesdayCard';
import WednesdayCard from './WeeksDays/WednesdayCard';
import ThursdayCard from './WeeksDays/ThursdayCard';
import FridayCard from './WeeksDays/FridayCard';
import SatuardayCard from './WeeksDays/SatuardayCard';
import ShowingSettings from './ShowingSettings';
import Footer from '../../../../components/common/Footer';
import SubHeading from '../../../../components/common/SubHeading';
import RightBar from '../../../../components/common/RightBar';

const { Search } = Input;
const onChange = (time, timeString) => {
    console.log(time, timeString);
}
const GeneralSettingsRightBar = [];

function ShowingAvailability() {

    return (
        <>
            <div className="page-container">
                <div className="main-container">
                    <PageHeading heading="Showing Availability" />
                    <SubHeading subHeading="Weekly Recurring Availability for aamir ali" />
                    <Space direction="vertical" size={16} style={{ display: 'flex' }}>

                        <SundayCard title="Sunday" />
                        <MondayCard title="Monday" />
                        <TuesdayCard title="Tuesday" />
                        <WednesdayCard title="Wednesday" />
                        <ThursdayCard title="Thursday" />
                        <FridayCard title="Friday" />
                        <SatuardayCard title="Satuarday" />
                        <br></br>
                        <ShowingSettings title="Showings Settings" />
                    </Space>
                    <Footer />
                </div>
            </div>
            <div className="RightSidebar">
                <RightBar RightBarData={GeneralSettingsRightBar} />
            </div>
        </>
    )
}

export default ShowingAvailability